import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取银行支行列表
   */
  static getBranchBankList(params) {
    return request({
      url: `basic/bank/query/bankBranch`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/BankSearch/indexServ.js